<template>
  <gg-card v-if="getDomainsTransferList.length" class="my-5">
    <gg-card-header>
      My Pending Transfers
      <gg-btn style="float: right;" :loading="loading" @click="refreshClick">Refresh</gg-btn>
    </gg-card-header>
    <gg-card-text>
      <v-data-table :loading="loading"
                    :headers="headers"
                    :items="getDomainsTransferList"
                    :footer-props="{ itemsPerPageOptions: pagination }"
                    :search="search">
        <template v-slot:item.domain="{ item }">
          <router-link :to="`/domaintransfer/${item.id}`" class="ggs-item-title">
            {{ item.domain }}
          </router-link>
        </template>
        <template v-slot:item.status="{ item }">
          <v-icon small class="pb-1" :color="statusColor(item.status)">
            mdi-circle
          </v-icon>
          <span class="pl-1">
            {{ item.status | capitalize }}
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <gg-btn color="primary" tile :to="`/domaintransfer/${item.id}`">
            Manage
          </gg-btn>
        </template>
      </v-data-table>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { statusColor } from '@/helpers/helpers'

export default {
  name: 'DomainsTransferList',

  props: {
    search: {
      type: String,
      required: false,
    }
  },

  data: () => ({
    headers: [
      {
        text: 'Domain',
        value: 'domain',
        sortable: true,
      },
      {
        text: 'Status',
        value: 'status',
        sortable: true,
      },
      {
        text: 'Date',
        value: 'created_at',
        sortable: true,
      },
      {
        text: 'Actions',
        value: 'actions',
        align: 'center',
        sortable: false,
      }
    ],
    loading: false
  }),

  computed: {
    ...mapGetters(['pagination', 'getDomainsTransferList']),
  },

  methods: {
    ...mapActions([ 'fetchDomainTransferList', 'getServices' ]),
    statusColor,
    async refreshClick () {
      try {
        this.loading = true
        await this.fetchDomainTransferList()
        await this.getServices()
      } catch (e) {
      } finally {
        this.loading = false
      }
    }
  },

  created () {
    this.fetchDomainTransferList()
  },

  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
}
</script>
